module.exports = __webpack_public_path__ + "img/logo-blanco.353dfa19.svg";